import styled from "styled-components";
import { Paper } from "@mui/material";

export const WearAndTearSquare = styled.img`
    align-self: center;
    text-align: center;
    display: flex;
`;
